var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "instagram 1",
    clipPath: "url(#clip0_11_106)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.481 0.863525H3.51898C1.57858 0.863525 0 2.44211 0 4.3825V10.3446C0 12.2849 1.57858 13.8635 3.51898 13.8635H9.4811C11.4214 13.8635 13 12.2849 13 10.3446V4.3825C13 2.44211 11.4214 0.863525 9.481 0.863525V0.863525ZM12.2379 10.3446C12.2379 11.8647 11.0012 13.1014 9.481 13.1014H3.51898C1.99881 13.1014 0.762114 11.8647 0.762114 10.3446V4.3825C0.762114 2.86234 1.99881 1.62564 3.51898 1.62564H9.4811C11.0012 1.62564 12.2379 2.86234 12.2379 4.3825V10.3446Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.49989 3.80884C4.53986 3.80884 2.94531 5.40339 2.94531 7.36342C2.94531 9.32345 4.53986 10.918 6.49989 10.918C8.45993 10.918 10.0545 9.32345 10.0545 7.36342C10.0545 5.40339 8.45993 3.80884 6.49989 3.80884ZM6.49989 10.1559C4.96019 10.1559 3.70743 8.90322 3.70743 7.36342C3.70743 5.82372 4.96019 4.57095 6.49989 4.57095C8.03969 4.57095 9.29236 5.82372 9.29236 7.36342C9.29236 8.90322 8.03969 10.1559 6.49989 10.1559Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.1402 2.54712C9.56096 2.54712 9.08984 3.01833 9.08984 3.59746C9.08984 4.17668 9.56096 4.64789 10.1402 4.64789C10.7194 4.64789 11.1906 4.17668 11.1906 3.59746C11.1906 3.01823 10.7194 2.54712 10.1402 2.54712ZM10.1402 3.88568C9.98129 3.88568 9.85196 3.75635 9.85196 3.59746C9.85196 3.43847 9.98129 3.30923 10.1402 3.30923C10.2992 3.30923 10.4285 3.43847 10.4285 3.59746C10.4285 3.75635 10.2992 3.88568 10.1402 3.88568Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_106"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(0 0.863525)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram1);
export default __webpack_public_path__ + "static/media/instagram 1.8cf57e3b477de3e4a74b68957775b0ec.svg";
export { ForwardRef as ReactComponent };